import 'intl-tel-input/dist/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';

function enablePhoneFields(scope) {
  scope.querySelectorAll('input[type="tel"]').forEach((field) => {
    const telInput = intlTelInput(field, {
      countrySelectorMode: 'OFF',
      onlyCountries: ['us'],
      loadUtils: () => import('intl-tel-input/dist/js/utils.js')
    });

    field.addEventListener('input', validatePhoneField);
    telInput.promise
      .then(() => validatePhoneField({ target: field }))
      .catch((error) => console.error(`Could not load intl-tel-input: ${error}`));
  });
}

function validatePhoneField (event) {
  const telInput = intlTelInput.getInstance(event.target);
  if (event.target.value && telInput?.isValidNumber() === false) {
    event.target.setCustomValidity('Please enter a valid US phone number, including area code. For example: “(311) 555-2368”.');
  } else {
    event.target.setCustomValidity('');
  }
}

document.addEventListener('turbolinks:load', () => {
  enablePhoneFields(document.body);
});
